import React from "react";

// Official R K STEEL logo — served locally for reliability (white background artwork)
export const LOGO_URL = "/rk-steel-logo.png";

// Full logo image
export const LogoImage = ({ className = "", alt = "R K STEEL — Recycling Today, Building Tomorrow" }) => (
  <img src={LOGO_URL} alt={alt} className={className} loading="eager" decoding="async" />
);

// Compact wordmark for navbar. Auto-adapts to dark backgrounds by wrapping in a subtle white card.
export const LogoMark = ({ variant = "auto", size = "md" }) => {
  const height = size === "sm" ? "h-8" : size === "lg" ? "h-16" : "h-10 md:h-11";
  return (
    <div className="flex items-center">
      <img
        src={LOGO_URL}
        alt="R K STEEL"
        className={`${height} w-auto object-contain`}
        loading="eager"
        decoding="async"
      />
    </div>
  );
};

export default LogoImage;
